var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "home-container" }, [
    _c(
      "div",
      { staticClass: "hx-breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { "separator-class": "el-icon-arrow-right" } },
          [
            _c("el-breadcrumb-item", [_vm._v("首页")]),
            _c("el-breadcrumb-item", [_vm._v("供应系统")]),
            _c("el-breadcrumb-item", [_vm._v("统计管理")]),
            _c("el-breadcrumb-item", [_vm._v("调查问卷统计报表")]),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "form-container box-shadow" }, [
      _c("div", { staticClass: "flex" }, [
        _c("div", { staticClass: "item" }, [
          _c("div", { staticClass: "label" }, [_vm._v("问卷名称：")]),
          _c("div", { staticClass: "content" }, [
            _vm._v(_vm._s(_vm.formData.questionnaireName)),
          ]),
        ]),
        _c("div", { staticClass: "item" }, [
          _c("div", { staticClass: "label" }, [_vm._v("保障用户人数：")]),
          _c("div", { staticClass: "content" }, [
            _vm._v(_vm._s(_vm.formData.supplyUserCount) + "人"),
          ]),
        ]),
        _c("div", { staticClass: "item" }, [
          _c("div", { staticClass: "label" }, [_vm._v("截止日期：")]),
          _c("div", { staticClass: "content" }, [
            _vm._v(_vm._s(_vm.formData.nowTime)),
          ]),
        ]),
        _c("div", { staticClass: "item" }, [
          _c("div", { staticClass: "label" }, [_vm._v("提交人数：")]),
          _c("div", { staticClass: "content" }, [
            _vm._v(_vm._s(_vm.formData.submitSupplyUserCount) + "人"),
          ]),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "form-container box-shadow" }, [
      _c(
        "div",
        { staticClass: "btn" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: { click: _vm.linkToAnotherPage },
            },
            [_vm._v("查看建议反馈")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "flex" },
        _vm._l(_vm.chartList, function (item, index) {
          return _c("div", { key: index, staticClass: "chart-item" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(item.problemName)),
            ]),
            _c("div", { staticClass: "chart" }, [
              _c("div", { staticClass: "left" }, [
                _c("div", { staticClass: "label" }, [_vm._v("答题人数（人）")]),
                _c("div", { staticClass: "content" }, [
                  _vm._v(_vm._s(item.submitSupplyUserCount)),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "right" },
                [
                  _c("PieChart", {
                    attrs: { data: _vm.formatChartData(item.proportion) },
                  }),
                ],
                1
              ),
            ]),
          ])
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }